import { LanguageEnum } from 'modules/common/enums'
import { ApiBuilderType } from 'modules/common/types'
import { NotificationTypeEnum } from 'modules/push-notifications/pages/TemplateEditor'

export interface NotificationTemplateType {
	id?: number // optional for new templates
	contentType: NotificationTypeEnum
	subType?: string // for lessons (newCycle) or other subtypes
	lessonName?: string
	language?: LanguageEnum
	enabled: boolean
	titleTemplate: string
	bodyTemplate: string
	createdAt?: string // optional, returned from backend
	updatedAt?: string // optional, returned from backend
}

export interface IGetNotificationTemplateParams {
	contentType: string
	language?: string
	subType?: string
}

export const getTemplate = (builder: ApiBuilderType) =>
	builder.query<NotificationTemplateType, IGetNotificationTemplateParams>({
		query: params => {
			return {
				url: '/notification-templates',
				method: 'GET',
				params,
			}
		},
	})
